export const persons = [
	{
		age: 31,
		category: 'Hamburg'
	},
	{
		age: 31,
		category: 'Hamburg'
	},
	{
		age: 31,
		category: 'Hamburg'
	},
	{
		age: 32,
		category: 'Hamburg'
	},
	{
		age: 32,
		category: 'New York'
	},
	{
		age: 32,
		category: 'New York'
	},
	{
		age: 32,
		category: 'Hamburg'
	},
	{
		age: 32,
		category: 'New York'
	},
	{
		age: 33,
		category: 'Hamburg'
	},
	{
		age: 33,
		category: 'Hamburg'
	},
	{
		age: 33,
		category: 'Hamburg'
	},
	{
		age: 33,
		category: 'Hamburg'
	},
	{
		age: 33,
		category: 'Hamburg'
	},
	{
		age: 33,
		category: 'New York'
	},
	{
		age: 33,
		category: 'Hamburg'
	},
	{
		age: 34,
		category: 'Hamburg'
	},
	{
		age: 34,
		category: 'New York'
	},
	{
		age: 34,
		category: 'Hamburg'
	},
	{
		age: 34,
		category: 'Hamburg'
	},
	{
		age: 34,
		category: 'New York'
	},
	{
		age: 34,
		category: 'Hamburg'
	},
	
	{
		age: 34,
		category: 'New York'
	},
	{
		age: 34,
		category: 'Hamburg'
	},
	{
		age: 35,
		category: 'New York'
	},
	{
		age: 35,
		category: 'Hamburg'
	},
	{
		age: 35,
		category: 'New York'
	},
	{
		age: 35,
		category: 'New York'
	},
	{
		age: 35,
		category: 'Hamburg'
	},
	{
		age: 35,
		category: 'New York'
	},
	{
		age: 35,
		category: 'Hamburg'
	},
	{
		age: 35,
		category: 'Hamburg'
	},
	{
		age: 35,
		category: 'New York'
	},
	{
		age: 36,
		category: 'Hamburg'
	},
	{
		age: 36,
		category: 'New York'
	},
	{
		age: 36,
		category: 'Hamburg'
	},
	{
		age: 36,
		category: 'New York'
	},
	{
		age: 36,
		category: 'Hamburg'
	},
	
	{
		age: 36,
		category: 'Hamburg'
	},
	{
		age: 36,
		category: 'New York'
	},
	{
		age: 37,
		category: 'Hamburg'
	},
	{
		age: 37,
		category: 'New York'
	},
	{
		age: 37,
		category: 'Hamburg'
	},
	{
		age: 37,
		category: 'New York'
	},
	{
		age: 37,
		category: 'Hamburg'
	},
	{
		age: 38,
		category: 'Hamburg'
	},
	{
		age: 38,
		category: 'Hamburg'
	},
	{
		age: 38,
		category: 'New York'
	},
];